import React, { FC } from 'react';

import { UserFeedFollowGroupFragment } from 'api';
import { GroupAvatar } from 'components';
import theme from 'theme';

interface Props {
  group: UserFeedFollowGroupFragment;
}

const styles = {
  borders: {
    borderRadius: theme.spacing(2, 0, 0, 2),
  },
} as const;

const ImageCell: FC<Props> = ({ group }) => (
  <GroupAvatar link group={group} size={100} sx={styles.borders} />
);

export default ImageCell;
